// // for production
// export const environment = {
//   production: true,
//   domain: 'https://shuwier.com/',
//   // endpoint: 'https://new-backend-shuwier.pomac.info/api', //---> Production
//   endpoint: 'https://backend.shuwier.com/api', //---> Development
//   // endpoint: 'http://192.168.1.32:8888/shuwier-backend/public/api', //---> Backend Local
//   //'https://backend.shuwier.com/api',
//   // files: 'https://new-backend-shuwier.pomac.info/',
//   chat: 'https://backend-chat.shuwier.com',
//   files: 'https://backend.shuwier.com/',
//   // files: 'http://192.168.1.32:8888/shuwier-backend/public/', //---> Backend Local
//   currentUserKey: 'shuwier_current_user',
//   is_production: true,
// };

//for development
export const environment = {
  production: false,
  domain: 'https://shuwier.com/',
  // endpoint: 'https://new-backend-shuwier.pomac.info/api', //---> Production
  endpoint: 'https://dev-backend.shuwier.com/api', //---> Development
  // endpoint: 'http://192.168.1.32:8888/shuwier-backend/public/api', //---> Backend Local
  //'https://backend.shuwier.com/api',
  // files: 'https://new-backend-shuwier.pomac.info/',
  chat: 'https://backend-chat.shuwier.com',
  files: 'https://dev-backend.shuwier.com/',
  // files: 'http://192.168.1.32:8888/shuwier-backend/public/', //---> Backend Local
  currentUserKey: 'shuwier_current_user',
  is_production: false,
};
